<template>
  <div
    class="bg-surface-container-low sticky top-0 flex min-h-16 w-full flex-row items-center overflow-hidden p-2 pl-14 lg:pl-2"
  >
    <Announcements />
    <div class="ml-auto flex shrink-0 items-center gap-2 self-start">
      <BaseIconButton
        v-if="!hideSettings"
        v-tooltip="$t('common.settings')"
        icon="settings"
        @click="router.push({ name: 'settings' })"
      ></BaseIconButton>
      <UserProfile />
    </div>
  </div>
</template>

<script setup lang="ts">
  import UserProfile from '@/modules/user/components/UserProfile.vue'
  import { useRouter } from 'vue-router'
  import BaseIconButton from '../base/button/icon-button/BaseIconButton.vue'
  import Announcements from '../announcement/Announcements.vue'

  interface Props {
    isExpanded: boolean
    hideSettings?: boolean
  }

  defineProps<Props>()

  defineEmits<{
    (e: 'toggleMenu'): void
  }>()

  const router = useRouter()
</script>
